module.exports = __webpack_public_path__ + "static/flags/FM-0450fc8375aef6c1ffa1f40072949cdb.gif";